export const updateCompany = (snap) => ({
  type: 'UPDATE_COMPANY',
  payload: snap
});
